import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import {
  AdimeResponseItem,
  HandoverResponseItem,
  ReadbackResponseItem
} from "@/types/cppt";
import Adime from "@/services/Adime";
import Handover from "@/services/Handover";
import Readback from "@/services/Readback";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "cppt-ranap-store"
})
class CpptRanapStore extends VuexModule {
  adimeLoading = false;
  adime: AdimeResponseItem[] = [];
  handoverLoading = false;
  handover: HandoverResponseItem[] = [];
  readbackLoading = false;
  readback: ReadbackResponseItem[] = [];

  get adimeList(): AdimeResponseItem[] {
    return this.adime.sort((a, b) => {
      return (
        new Date(b.examined_at).getTime() - new Date(a.examined_at).getTime()
      );
    });
  }

  get handoverList(): HandoverResponseItem[] {
    return this.handover.sort((a, b) => {
      return (
        new Date(b.transferred_at).getTime() -
        new Date(a.transferred_at).getTime()
      );
    });
  }

  get readbackList(): ReadbackResponseItem[] {
    return this.readback.sort((a, b) => {
      return (
        new Date(b.consulting_at).getTime() -
        new Date(a.consulting_at).getTime()
      );
    });
  }

  @Mutation
  SET_ADIME(val: AdimeResponseItem[]) {
    this.adime = val;
  }

  @Mutation
  SET_ADIME_LOADING(val: boolean) {
    this.adimeLoading = val;
  }

  @Mutation
  RESET_ADIME_LIST() {
    this.adime = [];
  }

  @Mutation
  SET_HANDOVER(val: HandoverResponseItem[]) {
    this.handover = val;
  }

  @Mutation
  SET_HANDOVER_LOADING(val: boolean) {
    this.handoverLoading = val;
  }

  @Mutation
  RESET_HANDOVER_LIST() {
    this.handover = [];
  }

  @Mutation
  SET_READBACK(val: ReadbackResponseItem[]) {
    this.readback = val;
  }

  @Mutation
  SET_READBACK_LOADING(val: boolean) {
    this.readbackLoading = val;
  }

  @Mutation
  RESET_READBACK_LIST() {
    this.readback = [];
  }

  @Action({ rawError: true })
  async getAdimeByRegister(registerId): Promise<void> {
    this.SET_ADIME_LOADING(true);
    const adime = await Adime.getByRegister(registerId).finally(() => {
      this.SET_ADIME_LOADING(false);
    });

    this.SET_ADIME(adime.data);
  }

  @Action({ rawError: true })
  async getHandoverByRegister(registerId): Promise<void> {
    this.SET_HANDOVER_LOADING(true);
    const handover = await Handover.getByRegister(registerId).finally(() => {
      this.SET_HANDOVER_LOADING(false);
    });

    this.SET_HANDOVER(handover.data);
  }

  @Action({ rawError: true })
  async getReadbackByRegister(registerId): Promise<void> {
    this.SET_READBACK_LOADING(true);
    const readback = await Readback.getByRegister(registerId).finally(() => {
      this.SET_READBACK_LOADING(false);
    });

    this.SET_READBACK(readback.data);
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_ADIME_LIST();
    this.RESET_HANDOVER_LIST();
    this.RESET_READBACK_LIST();
  }
}

export default getModule(CpptRanapStore);
